import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import type { TSelectedProductType } from 'shared/types/TCustomerService';

import type { TCreditFormEntityReducer } from '../../types';

export type TCreditPurposeFormViewOptions = {
  isCreditCardForm: boolean;
  isWithoutPeriod: boolean;
  isWithoutPurposeField: boolean;
};

type TGetCreditPurposeFormViewOptionsParams = {
  selectedProductType?: TSelectedProductType | null;
  withoutAdditionalFilters?: boolean;
  isCreditCardsForm?: boolean;
  isShowProductTypeSelection?: boolean;
};

export const getCreditPurposeFormViewOptions = ({
  selectedProductType,
  withoutAdditionalFilters,
  isCreditCardsForm,
  isShowProductTypeSelection,
}: TGetCreditPurposeFormViewOptionsParams): TCreditPurposeFormViewOptions => {
  const isCreditCardSelectedProductType =
    Boolean(isShowProductTypeSelection) && selectedProductType === PRODUCT_TYPES_VALUES.CREDIT_CARD;

  return {
    isCreditCardForm: Boolean(isCreditCardsForm || isCreditCardSelectedProductType),
    isWithoutPeriod: Boolean(withoutAdditionalFilters || isCreditCardSelectedProductType),
    isWithoutPurposeField: Boolean(withoutAdditionalFilters || isShowProductTypeSelection),
  };
};

export const getCreditPurposeFormViewOptionsFromEntityState = (
  state: TCreditFormEntityReducer,
  isShowProductTypeSelection = false,
): TCreditPurposeFormViewOptions => {
  const { blockFF } = state;
  const creditPurposeData = state.creditPurposeForm.data ?? state.creditPurposeForm.defaults;

  return getCreditPurposeFormViewOptions({
    selectedProductType: creditPurposeData.selectedProductType,
    withoutAdditionalFilters: blockFF?.withoutAdditionalFilters,
    isCreditCardsForm: blockFF?.isCreditCardsForm,
    isShowProductTypeSelection,
  });
};
